var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongoDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 73,
    viewBox: "0 0 33 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3944 29.0631C28.5256 12.0906 19.3798 6.51221 18.3973 4.38C17.5403 3.18158 16.775 1.47825 16.1476 0C16.0374 1.50563 15.9792 2.08354 14.5468 3.60133C12.3338 5.32292 0.962828 14.8008 0.0384591 34.0788C-0.824694 52.0612 13.1082 62.777 14.9998 64.1427L15.214 64.2948C15.6079 67.1897 15.9447 70.092 16.2241 73H17.6964C18.0453 69.861 18.5656 66.7463 19.2574 63.6621C20.5337 62.7618 21.1061 62.2538 21.8591 61.5542C25.4248 58.2762 28.2586 54.291 30.1772 49.8564C32.0959 45.4217 33.0566 40.6363 32.9974 35.8095C33.028 33.3336 32.6822 30.7543 32.3944 29.0631ZM16.0619 53.9896C16.0619 53.9896 16.0619 28.7711 16.9036 28.7742C17.5556 28.7742 18.4034 61.3048 18.4034 61.3048C17.2372 61.1679 16.0619 55.9515 16.0619 53.9896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDb);
export default __webpack_public_path__ + "static/media/MongoDB.bc8959657524ad1223e9f27c2ae9c8f4.svg";
export { ForwardRef as ReactComponent };